<template>
  <div>
    <SjScrollPageButtons
      :data="data"
      :pageSize="5"
      :itemSize="100"
      @select="onSelect"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: Array(17)
        .fill(0)
        .map((v, i) => {
          return {
            label: `测试${i}`,
            extra: `载荷${i}`
          };
        })
    };
  },
  methods: {
    onSelect(item) {
      this.$SjNotify({
        message: JSON.stringify(item)
      });
    }
  }
};
</script>

<style scoped lang="less"></style>
